import { Icon, IconVariant } from '@/components/Icon';
import { LottoBall, LottoBallVariant } from '@/components/LottoBall';
import { CouponGroupConfig, DrawTypeConfig } from '@/config/game';
import { CouponGroupState } from '@/reducers/couponGroup';
import React from 'react';

export interface SummaryCouponsNumbersProps {
  selectedNumbers: CouponGroupState;
  selectedPlayNumber: number[];
  superNumberIndex: number;
  gameShortName: string;
  drawTypes?: DrawTypeConfig[];
  couponGroupsConfig?: CouponGroupConfig;
  validCoupons: number;
}

export const SummaryCoupons: React.FC<
  React.PropsWithChildren<SummaryCouponsNumbersProps>
> = ({
  selectedNumbers,
  selectedPlayNumber,
  superNumberIndex,
  gameShortName,
  drawTypes,
  couponGroupsConfig,
  validCoupons,
}) => {
  const ballVariant = ((): LottoBallVariant => {
    switch (gameShortName) {
      case 'keno':
        return LottoBallVariant.Keno;
      case 'eurojackpot':
        return LottoBallVariant.Eurojackpot;
      default:
        return LottoBallVariant.Default;
    }
  })();

  return (
    <div className="SummaryCoupons">
      {Object.keys(selectedNumbers).map((couponIndex) => {
        if (selectedNumbers[couponIndex][0].length < 1) {
          return null;
        }

        return (
          <div className="SummaryCoupons__coupon" key={couponIndex}>
            {Object.keys(selectedNumbers[couponIndex]).map((couponGroupId) => {
              if (Number(couponIndex).valueOf() > validCoupons) {
                return null;
              }
              if (selectedNumbers[couponIndex][couponGroupId].length < 1) {
                return null;
              }

              const groupName =
                couponGroupsConfig &&
                couponGroupsConfig.numberGroups[+couponGroupId] &&
                couponGroupsConfig.numberGroups[+couponGroupId].name &&
                couponGroupsConfig.numberGroups[+couponGroupId].name;

              const selectedCouponGroupNumbers =
                selectedNumbers[couponIndex][couponGroupId];
              const drawType =
                drawTypes &&
                drawTypes.find(
                  (item) => item.value === selectedCouponGroupNumbers.length
                );

              return (
                <React.Fragment key={couponGroupId}>
                  {drawType && (
                    <div className="SummaryCoupons__numberGroup-title">
                      {drawType.label}
                    </div>
                  )}

                  <div
                    className="SummaryCoupons__numberGroup"
                    key={couponGroupId}
                  >
                    {+couponGroupId === 1 && (
                      <Icon
                        variant={IconVariant.Plus}
                        className="SummaryCoupons__numberGroupIcon"
                      />
                    )}
                    {selectedCouponGroupNumbers
                      .sort((a, b) => a - b)
                      .map((value) => {
                        return (
                          <LottoBall
                            key={value}
                            variant={ballVariant}
                            value={value}
                            small={true}
                            className="SummaryCoupons__number"
                          />
                        );
                      })}
                  </div>
                  {superNumberIndex > -1 &&
                    selectedPlayNumber &&
                    selectedPlayNumber.length > 0 && (
                      <div className="SummaryCoupons__numberGroup">
                        <Icon
                          variant={IconVariant.Plus}
                          className="SummaryCoupons__numberGroupIcon"
                        />
                        <LottoBall
                          variant={ballVariant}
                          value={selectedPlayNumber[superNumberIndex]}
                          small={true}
                          key={selectedPlayNumber[superNumberIndex]}
                          className="SummaryCoupons__superNumber"
                        />
                        <span className="SummaryCoupons__superNumberTitle">
                          Superzahl
                        </span>
                      </div>
                    )}
                  {groupName && (
                    <span className="SummaryCoupons__superNumberTitle">
                      {groupName}
                    </span>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
